<div
  class="dialog-overlay"
  *ngIf="slideState === 'hidden' || slideState === 'visible'"
  (click)="closeModal()"
></div>

<div class="dialog-box" [@slideDialog]="slideState">
  <div
    class="card"
    tabindex="0"
    role="button"
    [attr.aria-label]="'Warning'"
  >
    <div class="modal-header">
      Login to access this feature
    </div>
    <div class="flex gap-2" style="margin-block-start: 2rem;">
      <app-button class="flex-grow" (click)="closeModal()" [isDefault]="false" text="Cancel"></app-button>
      <app-button class="flex-grow" routerLink="/auth/login" text="Login"></app-button>
    </div>
 


  </div>
</div>

